import { InstagramCallbackTemplate } from "@/components/Templates";
import {
  type InstagramCallbackParams,
  useInstagramCallbackPage,
} from "@/hooks/useInstagramCallbackPage";

export function InstagramCallbackPage(params: InstagramCallbackParams) {
  const callback = useInstagramCallbackPage(params);

  return <InstagramCallbackTemplate {...callback} />;
}
